const layout = {
  xs: 12
};

export default ({ key, label, tab }) => ({
  [key]: {
    tab,
    label,
    component: 'fieldset',
    layout: {
      ...layout
    },
    type: 'object',
    properties: {
      title: {
        layout: {
          ...layout
        },
        type: 'string',
        label: 'Title',
        component: 'text'
      },
      description: {
        layout: {
          ...layout
        },
        type: 'string',
        label: 'Description',
        component: 'wysiwyg'
      },
      [key]: {
        layout: {
          ...layout
        },
        type: 'array',
        label: [label],
        component: 'repeater',
        properties: {
          title: {
            layout: {
              ...layout
            },
            type: 'string',
            label: 'Title',
            component: 'text'
          },
          images: {
            layout: {
              ...layout
            },
            type: 'array',
            label: 'Image',
            component: 'file'
          },
          content: {
            layout: {
              ...layout
            },
            type: 'array',
            label: 'Content',
            component: 'wysiwyg'
          }
        }
      }
    }
  }
});
